<template>
<div class="k-user">
    <img :src="logo" class="k-user__logo">
    <span class="k-user__nick">{{nick}}</span>
</div>
</template>

<script>
    export default {
        name: 'k-user',
        props: ['nick', 'logo']
    }
</script>
<style lang="less" scoped>
    .k-user {
        display: flex;
        align-items: center;
    }
    .k-user__logo {
        border-radius: 100px;
        width: 0.6rem;
        height: 0.6rem;
        vertical-align: middle;
        margin-right: 0.1rem;
    }
    .k-user__nick {
        line-height: 1.2;
        font-size: 0.24rem;
    }
</style>
